interface NFT {
  [key: string]: any;
}
interface MappedNFT {
  _id: number | null;
  imageUrl: string | null;
  name: string | null;
  tokenId: number;
  revealed: null;
  originalImageUrl: string;
  tokenMetadata: string | object;
  openseaRefreshed: null;
}

export default function mapBlockchainData(
  NFTs: NFT[],
  collectionName: string | undefined
): MappedNFT[] {
  return NFTs.map((e) => {
    let zeroTokenId = e.tokenId === 0 ? 0 : null;
    let tokenId = e.tokenId || zeroTokenId;
    let image = e.image || e.imageUrl;
    return {
      _id: tokenId,
      name: e.name,
      imageUrl: image,
      tokenId: tokenId,
      revealed: null,
      originalImageUrl: image,
      tokenMetadata: e,
      openseaRefreshed: null,
      collectionName: collectionName,
    };
  });
}

// {
//"_id":1,
// "imageUrl":"https://lh3.googleusercontent.com/9WkSu8CP7gZjaEmUy8cpaKG3mK6ScHeEDvQf8driDoRxuxy4GPAs_W_Dn_DQascQSGDkdUL4cjmsnRrL6xN-NDp-s_RNwN5pxiCo",
// "tokenId":1,
//"originalImageUrl":"ipfs://QmPbxeGcXhYQQNgsC6a36dDyYUcHgMLnGKnF8pVFmGsvqi",
// "tokenMetadata":"https://opensea.mypinata.cloud/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/1",
// "revealed":true,
// "openseaRefreshed":true
// }
